enum Language {
  MULTI = 'MULTI',
  NL = 'NL',
  FR = 'FR',
  EN = 'EN',
  DE = 'DE',
}

export default Language;
